/* Zemulo: the terms checkbox in the cart (a reminder; consent is given by placing the order, see terms §7).
   Above the checkout button, in the cart page and in the cart drawer: a checkbox
   "קראתי ואני מסכים/ה לתקנון האתר, למדיניות הביטולים ולמדיניות הפרטיות", with links.
   Until it is ticked, neither the checkout button nor the express buttons (PayPal) lead to payment:
   a click shows a short message instead. The tick is kept for this visit (sessionStorage),
   so a redrawn cart keeps it. */
(function () {
  var KEY = 'zt-agree';
  var root = document.documentElement;

  var css = document.createElement('style');
  css.textContent =
    '.zt-agree{margin:0 0 12px;direction:rtl;text-align:right}' +
    '.zt-agree label{display:flex;align-items:flex-start;gap:9px;cursor:pointer;font-size:13.5px;line-height:1.45;color:#2b2b2b}' +
    '.zt-agree input{flex:0 0 auto;width:19px;height:19px;margin:1px 0 0;accent-color:var(--z-accent,#ff5a1f);cursor:pointer}' +
    '.zt-agree a{color:inherit;text-decoration:underline;text-underline-offset:2px}' +
    '.zt-err{margin:7px 0 0;font-size:12.5px;font-weight:700;color:#c62619}' +
    '.zt-agree.is-error label{color:#c62619}' +
    'html:not(.zt-ok) button[name="checkout"]{opacity:.55}' +
    'html:not(.zt-ok) .cart__dynamic-checkout-buttons{position:relative;opacity:.45;filter:grayscale(1)}' +
    'html:not(.zt-ok) .cart__dynamic-checkout-buttons::after{content:"";position:absolute;inset:0;z-index:5;cursor:not-allowed}';
  document.head.appendChild(css);

  function agreed() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return root.classList.contains('zt-ok'); }
  }

  /* record the tick on the cart, so it shows in the order (Additional details) */
  function recordConsent(on) {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'אישור תקנון': on ? new Date().toISOString() : '' } }) }).catch(function () {});
  }

  function setAgreed(on) {
    try {
      if (on) sessionStorage.setItem(KEY, '1');
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
    root.classList.toggle('zt-ok', on);
    recordConsent(on);
    document.querySelectorAll('.zt-agree').forEach(function (box) {
      box.querySelector('.zt-check').checked = on;
      if (on) {
        box.classList.remove('is-error');
        box.querySelector('.zt-err').hidden = true;
      }
    });
  }

  function makeBox() {
    var box = document.createElement('div');
    box.className = 'zt-agree';
    box.innerHTML =
      '<label><input type="checkbox" class="zt-check" required>' +
      '<span>קראתי ואני מסכים/ה ל<a href="/policies/terms-of-service" target="_blank" rel="noopener">תקנון האתר</a>, ' +
      'ל<a href="/policies/refund-policy" target="_blank" rel="noopener">מדיניות הביטולים וההחזרות</a> ' +
      'ול<a href="/policies/privacy-policy" target="_blank" rel="noopener">מדיניות הפרטיות</a></span></label>' +
      '<p class="zt-err" hidden>נא לסמן שקראתם את התקנון ואת מדיניות הביטולים והפרטיות</p>';
    box.querySelector('.zt-check').checked = agreed();
    box.querySelector('.zt-check').addEventListener('change', function (e) { setAgreed(e.target.checked); });
    return box;
  }

  /* one box above every group of checkout buttons; safe to run again and again */
  function place() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prev = ctas.previousElementSibling;
      if (prev && prev.classList.contains('zt-agree')) return;
      ctas.parentNode.insertBefore(makeBox(), ctas);
    });
  }

  function warn(from) {
    var scope = (from && from.closest('.drawer__footer, .cart__blocks, form, section')) || document;
    var box = scope.querySelector('.zt-agree') || document.querySelector('.zt-agree');
    if (!box) return;
    box.classList.add('is-error');
    box.querySelector('.zt-err').hidden = false;
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    if (agreed() || !e.target.closest) return;
    var hit = e.target.closest('button[name="checkout"], .cart__dynamic-checkout-buttons, a[href^="/checkout"]');
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    warn(hit);
  }, true);

  document.addEventListener('submit', function (e) {
    if (agreed()) return;
    var by = e.submitter;
    if (by && by.name === 'checkout') {
      e.preventDefault();
      e.stopImmediatePropagation();
      warn(by);
    }
  }, true);

  root.classList.toggle('zt-ok', agreed());
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; place(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  else place();
})();
